import Header from "@/components/landing/Header";
import HeroSection from "@/components/landing/HeroSection";
import PainPointsSection from "@/components/landing/PainPointsSection";
import BenefitsSection from "@/components/landing/BenefitsSection";
import CoursesSection from "@/components/landing/CoursesSection";
import CTASection from "@/components/landing/CTASection";
import Footer from "@/components/landing/Footer";
import SEO from "@/components/SEO";


const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEO
        title="Digital Bridge | Marketing Solutions & Digital Solutions"
        description="Digital Bridge is a full-service marketing agency helping businesses elevate their brand and monetize talents through strategy, creativity, and media."
        keywords="Digital Bridge, marketing agency, digital solutions, brand strategy, Saudi Arabia"
      />
      <Header />
      <main>
        <HeroSection />
        <PainPointsSection />
        <BenefitsSection />
        <CoursesSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
